// extracted by mini-css-extract-plugin
export var divider = "_s7-0";
export var systemMessage = "_s7-1";
export var systemMessageWrapper = "_s7-2";